<div class="container-fluid bg-white vh-100 p-0">
    <div class="d-flex flex-column align-items-center min-vh-50">
        <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
            <div class="d-flex align-items-center">
                <span><i class="text-muted bi bi-question-circle me-3"></i></span>
                <span class="text-muted text-xs">
                    Please provide your current physical address and postal address information. This information is
                    needed for verification and correspondence purposes.
                </span>
            </div>

            <div class="form-group mt-3">
                <div class="mb-4 p-3 border rounded shadow-sm">
                    <h5 class="fw-bold mb-3">Physical Address</h5>                        
                    <!-- Address Line 1 -->
                    <label for="physical_address1" class="fw-bold text-xs text-start d-block">Address Line 1 <span
                            class="text-danger">*</span></label>
                    <input v-model="client_physical_address_1" type="text" class="form-control rounded-small shadow-sm w-100"
                        id="physical_address1" placeholder="Enter address line 1" maxlength="50" required />
                    <small v-if="error_messages.client_physical_address_1" class="form-text text-danger text-xs fw-bold">
                        {{ error_messages.client_physical_address_1 }}
                    </small>
    
                    <!-- Address Line 2 -->
                    <label for="physical_address2" class="fw-bold text-xs text-start d-block mt-3">Address Line 2</label>
                    <input v-model="client_physical_address_2" type="text" class="form-control rounded-small shadow-sm w-100"
                        id="physical_address2" placeholder="Enter address line 2 (optional)" maxlength="50" />
                    <small v-if="error_messages.client_physical_address_2" class="form-text text-danger text-xs fw-bold">
                        {{ error_messages.client_physical_address_2 }}
                    </small>
    
                    <!-- Suburb -->
                    <label for="physical_suburb" class="fw-bold text-xs text-start d-block mt-3">Suburb <span
                            class="text-danger">*</span></label>
                    <div class="position-relative">
                        <input v-model="physical_suburb_search" type="text" class="form-control rounded-small shadow-sm w-100"
                            id="physical_suburb" placeholder="Type to search suburb..." maxlength="50" required
                            @input="search_physical_postal_codes"
                            @blur="hide_physical_dropdown"
                            autocomplete="off" />
                        <div v-if="physical_search_loading" class="position-absolute end-0 top-50 translate-middle-y me-2">
                            <span class="spinner-border spinner-border-sm text-muted" role="status"></span>
                        </div>
                        <ul v-if="physical_show_dropdown && physical_postal_code_results.length > 0" 
                            class="list-group position-absolute w-100 shadow-sm dropdown-list">
                            <li v-for="result in physical_postal_code_results" :key="result.id"
                                class="list-group-item list-group-item-action text-xs py-2 dropdown-item-clickable"
                                @mousedown.prevent="select_physical_postal_code(result)">
                                <strong>{{ result.suburb }}</strong> - {{ result.postal_code }}
                                <span v-if="result.area" class="text-muted ms-1">({{ result.area }})</span>
                            </li>
                        </ul>
                    </div>
                    <input type="hidden" v-model="client_physical_suburb" />
                    <small v-if="error_messages.client_physical_suburb" class="form-text text-danger text-xs fw-bold">
                        {{ error_messages.client_physical_suburb }}
                    </small>
    
                    <!-- City/Town -->
                    <label for="physical_city" class="fw-bold text-xs text-start d-block mt-3">City/Town <span
                            class="text-danger">*</span></label>
                    <input v-model="client_physical_city" type="text" class="form-control rounded-small shadow-sm w-100"
                        id="physical_city" placeholder="Enter city or town" maxlength="50" required />
                    <small v-if="error_messages.client_physical_city" class="form-text text-danger text-xs fw-bold">
                        {{ error_messages.client_physical_city }}
                    </small>
    
                    <!-- Post Code -->
                    <label for="physical_postcode" class="fw-bold text-xs text-start d-block mt-3">Post Code <span
                            class="text-danger">*</span></label>
                    <input v-model="client_physical_post_code" type="text" class="form-control rounded-small shadow-sm w-100 bg-light"
                        id="physical_postcode" placeholder="Auto-filled from suburb selection" maxlength="10" required readonly />
                    <small class="form-text text-muted text-xs">Post code is automatically filled when you select a suburb.</small>
                    <small v-if="error_messages.client_physical_post_code" class="form-text text-danger text-xs fw-bold">
                        {{ error_messages.client_physical_post_code }}
                    </small>
    
                    <!-- Province -->
                    <label for="physical_province" class="fw-bold text-xs text-start d-block mt-3">Province <span
                            class="text-danger">*</span></label>
                    <!-- Province Select (Physical) -->
                    <select v-model="client_physical_province" class="form-select rounded-small shadow-sm w-100"
                        id="physical_province" required>
                        <option value="" disabled selected>Select province</option>
                        <option v-for="province in province_options" :key="province.value" :value="province.value">
                            {{ province.label }}
                        </option>
                    </select>
                    <small v-if="error_messages.client_physical_province" class="form-text text-danger text-xs fw-bold">
                        {{ error_messages.client_physical_province }}
                    </small>

                    <!-- Country -->
                    <label for="client_physical_country" class="fw-bold text-xs text-start d-block mt-3">Country <span
                        class="text-danger">*</span></label>
                    <!-- Country Select (Physical) -->
                    <select v-model="client_physical_country" class="form-select rounded-small shadow-sm w-100"
                        id="client_physical_country" required>
                        <option value="" disabled selected>Select country</option>
                        <option v-for="country in country_options" :key="country.value" :value="country.value">
                            {{ country.label }}
                        </option>
                    </select>
                    <small v-if="error_messages.client_physical_country" class="form-text text-danger text-xs fw-bold">
                        {{ error_messages.client_physical_country }}
                    </small>

                    <!-- Start Living Date -->
                    <label for="physical_address_date" class="fw-bold text-xs text-start d-block mt-3">When did you start
                        living here? <span class="text-danger">*</span></label>
                    <input v-model="client_physical_address_date" type="date" class="form-control rounded-small shadow-sm w-100"
                        id="physical_address_date" required />
                    <small v-if="error_messages.client_physical_address_date" class="form-text text-danger text-xs fw-bold">
                        {{ error_messages.client_physical_address_date }}
                    </small>
    
                    <!-- Residential Status -->
                    <label for="residential_status" class="fw-bold text-xs text-start d-block mt-3">Residential Status <span
                            class="text-danger">*</span></label>
                    <!-- Residential Status Select -->
                    <select v-model="client_residential_status" class="form-select rounded-small shadow-sm w-100"
                        id="residential_status" required>
                        <option value="" disabled selected>Select residential status</option>
                        <option v-for="status in residential_status_options" :key="status.value" :value="status.value">
                            {{ status.label }}
                        </option>
                    </select>
                    <small v-if="error_messages.client_residential_status" class="form-text text-danger text-xs fw-bold">
                        {{ error_messages.client_residential_status }}
                    </small>
                    <small class="form-text text-muted text-xs">
                        This will impact which housing-related fields are required on the financial information form.
                    </small>
                </div>

                <div class="mb-4 p-3 border rounded shadow-sm">
                    <!-- Postal Address Section -->
                    <div class="mt-4 mb-3">
                        <h5 class="fw-bold">Postal Address</h5>
    
                        <!-- Same as Physical Address Option -->
                        <div class="form-check mt-2">
                            <input v-model="same_as_physical" class="form-check-input" type="checkbox" id="same_as_physical"
                                @change="copy_physical_address" />
                            <label class="form-check-label text-xs" for="same_as_physical">
                                Same as Physical Address
                            </label>
                        </div>
                    </div>

                    <!-- Postal Address Fields (conditionally hidden if same as physical) -->
                    <div v-show="!same_as_physical">
                        <!-- Address Line 1 -->
                        <label for="postal_address1" class="fw-bold text-xs text-start d-block mt-3">Address Line 1 <span
                                class="text-danger">*</span></label>
                        <input v-model="client_postal_address_1" type="text" class="form-control rounded-small shadow-sm w-100"
                            id="postal_address1" placeholder="Enter address line 1" maxlength="50" required />
                        <small v-if="error_messages.client_postal_address_1" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_postal_address_1 }}
                        </small>
    
                        <!-- Address Line 2 -->
                        <label for="postal_address2" class="fw-bold text-xs text-start d-block mt-3">Address Line 2</label>
                        <input v-model="client_postal_address_2" type="text" class="form-control rounded-small shadow-sm w-100"
                            id="postal_address2" placeholder="Enter address line 2 (optional)" maxlength="50" />
                        <small v-if="error_messages.client_postal_address_2" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_postal_address_2 }}
                        </small>
    
                        <!-- Suburb -->
                        <label for="postal_suburb" class="fw-bold text-xs text-start d-block mt-3">Suburb <span
                                class="text-danger">*</span></label>
                        <div class="position-relative">
                            <input v-model="postal_suburb_search" type="text" class="form-control rounded-small shadow-sm w-100"
                                id="postal_suburb" placeholder="Type to search suburb..." maxlength="50" required
                                @input="search_postal_postal_codes"
                                @blur="hide_postal_dropdown"
                                autocomplete="off" />
                            <div v-if="postal_search_loading" class="position-absolute end-0 top-50 translate-middle-y me-2">
                                <span class="spinner-border spinner-border-sm text-muted" role="status"></span>
                            </div>
                            <ul v-if="postal_show_dropdown && postal_postal_code_results.length > 0" 
                                class="list-group position-absolute w-100 shadow-sm dropdown-list">
                                <li v-for="result in postal_postal_code_results" :key="result.id"
                                    class="list-group-item list-group-item-action text-xs py-2 dropdown-item-clickable"
                                    @mousedown.prevent="select_postal_postal_code(result)">
                                    <strong>{{ result.suburb }}</strong> - {{ result.postal_code }}
                                    <span v-if="result.area" class="text-muted ms-1">({{ result.area }})</span>
                                </li>
                            </ul>
                        </div>
                        <input type="hidden" v-model="client_postal_suburb" />
                        <small v-if="error_messages.client_postal_suburb" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_postal_suburb }}
                        </small>
    
                        <!-- City/Town -->
                        <label for="postal_city" class="fw-bold text-xs text-start d-block mt-3">City/Town <span
                                class="text-danger">*</span></label>     
                        <input v-model="client_postal_city" type="text" class="form-control rounded-small shadow-sm w-100"
                            id="postal_city" placeholder="Enter city or town" maxlength="50" required />
                        <small v-if="error_messages.client_postal_city" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_postal_city }}
                        </small>
    
                        <!-- Post Code -->
                        <label for="postal_postcode" class="fw-bold text-xs text-start d-block mt-3">Post Code <span
                                class="text-danger">*</span></label>
                        <input v-model="client_postal_post_code" type="text" class="form-control rounded-small shadow-sm w-100 bg-light"
                            id="postal_postcode" placeholder="Auto-filled from suburb selection" maxlength="10" required readonly />
                        <small class="form-text text-muted text-xs">Post code is automatically filled when you select a suburb.</small>
                        <small v-if="error_messages.client_postal_postcode" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_postal_postcode }}
                        </small>
    
                        <!-- Province -->
                        <label for="postal_province" class="fw-bold text-xs text-start d-block mt-3">Province <span
                                class="text-danger">*</span></label>
                        <!-- Province Select (Postal) -->
                        <select v-model="client_postal_province" class="form-select rounded-small shadow-sm w-100"
                            id="postal_province" required>
                            <option value="" disabled selected>Select province</option>
                            <option v-for="province in province_options" :key="province.value" :value="province.value">
                                {{ province.label }}
                            </option>
                        </select>
                        <small v-if="error_messages.client_postal_province" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_postal_province }}
                        </small>

                        <!-- Country -->
                        <label for="client_postal_country" class="fw-bold text-xs text-start d-block mt-3">Country <span
                            class="text-danger">*</span></label>
                        <!-- Country Select (Postal) -->
                        <select v-model="client_postal_country" class="form-select rounded-small shadow-sm w-100"
                            id="client_postal_country" required>
                            <option value="" disabled selected>Select country</option>
                            <option v-for="country in country_options" :key="country.value" :value="country.value">
                                {{ country.label }}
                            </option>
                        </select>
                        <small v-if="error_messages.client_postal_country" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_postal_country }}
                        </small>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-center mb-3 mt-4">
            <button type="button" @click="$emit('previous')" class="btn btn-bg-secondary text-xs fw-bold rounded-small shadow-sm me-1">
                Previous
            </button>
            <button class="btn btn-sm bg-green text-dark rounded-small fw-bold secondary-text-dark shadow-sm"
                @click="save_address_details"
                >
                Continue
            </button>
        </div>
    </div>
</div>